import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Icon from './Icon'
import zIndex from '../../utils/zIndexScale'

import { FormatText } from '../../i18n/util'

const Wrapper = styled.div`
  margin-top: 20px;
  position: relative;
  .inputWrap {
    position: relative;
    z-index: ${zIndex.input};
  }
  input {
    border: none;
    border-radius: 0;
    width: 100%;
    height: 100%;
    outline: none;
    font-size: 14px;
    border-bottom: 1px solid ${props => props.borderColor};
    caret-color: #f0b90b;
    padding: 0;
    padding-bottom: 10px;
    color: ${({ theme }) => theme.fontColor};
    background: inherit;
    position: relative;
    &:focus {
      border-color: #f0b90b;
    }
  }
  .label {
    font-size: 16px;
    position: absolute;
    transform: translateY(0px);
    transition: all 0.2s ease;
    z-index: ${zIndex.inputLabel};
    color: #848e9c;
  }
  .label-value {
    transform: translateY(-20px);
    color: ${({ theme }) => theme.fontColor};
    font-size: 12px;
  }
`

const EyeWrap = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  color: ${({ theme }) => theme.fontColor};
  cursor: pointer;
`

const Clear = styled.div`
  position: absolute;
  right: 25px;
  top: 0;
  color: ${({ theme }) => theme.fontColor};
  cursor: pointer;
`

const Rules = styled.div`
  margin-top: 5px;
  background: #fbfbfb;
  padding: 10px;
  border: 1px solid rgba(234, 236, 239, 0.5);
  .text {
    font-size: 14px;
    color: ${({ theme }) => theme.fontColor};
    line-height: 14px;
    margin-bottom: 10px;
  }
  ul {
    color: #263147;
    display: flex;
    justify-content: flex-start;
    padding-left: 15px;
    li {
      position: relative;
      font-size: 12px;
      white-space: nowrap;
      &:first-child {
        margin-right: 60px;
      }
      &:before {
        content: '';
        position: absolute;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #848e9c;
        top: 5px;
        left: -15px;
        transition: background 0.25s ease;
      }
    }
    li.pass {
      &:before {
        background: #00c087;
      }
    }
    li.invalid {
      color: #f23051;
      &:before {
        background: #f23051;
      }
    }
    @media (min-width: 320px) and (max-width: 623px) {
      flex-direction: column;
    }
  }
`

class InputPassword extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    withRules: PropTypes.bool,
    autoFocus: PropTypes.bool,
    warning: PropTypes.bool,
    title: PropTypes.string,
  }

  static defaultProps = {
    onChange: () => {},
    withRules: true,
    autoFocus: false,
    warning: false,
    title: <FormatText value="inputPassword.setANewPassword" />,
  }

  constructor(props) {
    super(props)
    this.state = {
      showPassword: false,
      value: '',
      pwdReadOnly: true,
    }
  }

  componentDidMount() {
    //* TODO* autocomplete will not work in some browsers. use read only to hack it
    setTimeout(() => {
      this.setState({ pwdReadOnly: false })
    }, 40)
  }

  _clear = () => {
    const { onChange } = this.props
    this.setState({ value: '' }, () => {
      onChange('', false)
    })
  }

  _showPassword = () => {
    const { showPassword } = this.state
    this.setState({ showPassword: !showPassword })
  }

  _passwordChange = e => {
    const { onChange } = this.props
    const value = e.currentTarget.value.trim()
    /* eslint-disable */
    const lengthRule = !value ? 'empty' : value.length >= 8 ? 'pass' : 'invalid'
    const multiCharacterRule = !value
      ? 'empty'
      : /^(?=.*[A-Z])(?=.*\d)(?=.*[\W])[A-Za-z\d\W]*/.test(value)
      ? 'pass'
      : 'invalid'
    this.setState({ value }, () => {
      onChange(value, lengthRule === 'pass' && multiCharacterRule === 'pass')
    })
  }

  render() {
    const { showPassword, value, pwdReadOnly } = this.state
    const { withRules, title, autoFocus, warning } = this.props

    const lengthRule = !value ? 'empty' : value.length >= 8 ? 'pass' : 'invalid'
    const multiCharacterRule = !value
      ? 'empty'
      : /^(?=.*[A-Z])(?=.*\d)(?=.*[\W])[A-Za-z\d\W]*/.test(value)
      ? 'pass'
      : 'invalid'

    return (
      <Wrapper borderColor={!warning ? 'rgba(234,236,239,0.5)' : 'rgba(242,48,81,0.5)'}>
        <p className={value ? 'label label-value' : 'label'}>{title}</p>
        <div className="inputWrap">
          <input
            type={showPassword ? 'text' : 'password'}
            // placeholder={title}
            value={value}
            autoFocus={autoFocus}
            autocomplete="off"
            onChange={this._passwordChange}
            readOnly={pwdReadOnly}
          />
          <EyeWrap onClick={this._showPassword}>
            <Icon type={showPassword ? 'eye' : 'blind-eye'} size="14" />
          </EyeWrap>
          {value && (
            <Clear onClick={this._clear}>
              <Icon type="clear" size="14" />
            </Clear>
          )}
        </div>
        {withRules && (
          <Rules>
            <div className="text">
              <FormatText value="inputPassword.passwordRule" />:{' '}
            </div>
            <ul>
              <li className={lengthRule}>
                <FormatText value="inputPassword.passwordRule1" />
              </li>
              <li className={multiCharacterRule}>
                <FormatText value="inputPassword.passwordRule2" />
              </li>
            </ul>
          </Rules>
        )}
      </Wrapper>
    )
  }
}

export default InputPassword
